import { Box, InputLabel, Stack, styled, TextField, Tooltip, tooltipClasses, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { ftchPlus, getOptions, putOptions, ScenOptionUrl_spec } from "../App/Account_urls";
import { InputYear } from "../Components/Inputs/Input_Year";
import { InputMoney } from "../Components/Inputs/Input_Money";
import { Money } from "../Functions/savingRuleText";
import { AddDialog } from "../Components/AddDialog";
import { Arrayify } from "../Functions/utils";
import { CollapseAdd } from "../App/CollapseButtons";
import { InputSelect1 } from "../Components/Inputs/Select";
import { faRotateRight, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { activeToggleColor, creditsRemainingColor, defaultColor, iconSize, myOwnFPColor } from "../App/GridRenderers";
import { APIs_simpleTax } from "../App/api";
import { errorClear } from "../Components/Inputs/Input_Fns";
import { set } from "lodash";
import DOMPurify from "dompurify";
import { CrumbToggleScenario } from "../Components/CrumbToggles";
import { GoogleAnalyticsEvent } from "../Components/ga4";
import { Input_label } from "../Components/Inputs/Input_Name";



const TaxInput = ({ input, avail, onDelete, onSubmit, onChange }) => {
    const disabled = false

    const myChangeNV = (n, v) => {
        let nf = structuredClone(input);
        nf = set(nf, n, v);


        onChange(nf);
        return nf
    };



    const myChangeEvent = (e) => {
        //console.log(e)
        return myChangeNV(e.target.name, e.target.value)
    }

    const myChangeClient = (c) => {
        //console.log(c)
        myChangeNV("Client", c)
    }

    return (
        <Stack spacing={2}>
            <Stack direction="row" spacing={2}>
                {/* <Input_label
                    label={input.Label}
                    name="Label"
                    onChange={myChangeEvent}

                /> */}
                <CrumbToggleScenario
                    current={input.Client}
                    set={avail.Clients}
                    clientJson={null}
                    onChange={myChangeClient}

                />
                <InputYear
                    year={input.Year}
                    name="Year"
                    onChange={myChangeEvent}
                    birthYear={avail.ClientData[input.Client].BirthYear}
                    width={80}
                />
                <InputSelect1
                    label="Province"
                    name="Province"
                    value={input.Province}
                    onChange={myChangeEvent}
                    avail={avail.Provinces}
                    maxWidth={80}
                    minWidth={80}
                />


                <Stack sx={{ pl: 4, pt: 2 }}>
                    <FontAwesomeIcon
                        icon={faTrashAlt}
                        onClick={disabled ? () => { } : onDelete}
                        size={iconSize}
                        color={"black"}
                    />
                </Stack>
            </Stack>
            <Input_label
                label="Notes"
                value={input.Notes}
                name="Notes"
                onChange={myChangeEvent}
                maxLength={400}
                width={340}
                required={false}
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center', // Centers horizontally
                }}
            >
                <Stack spacing={2}>


                    <InputMoney
                        xlabel="Employment"
                        money={input.Employment}
                        name="Employment"
                        onChange={myChangeEvent}

                    />
                    <InputMoney
                        xlabel="Pension Income"
                        money={input.PensionIncome}
                        name="PensionIncome"
                        onChange={myChangeEvent}

                    />
                    <InputMoney
                        xlabel="Income"
                        money={input.Income}
                        name="Income"
                        onChange={myChangeEvent}

                    />
                    <InputMoney
                        xlabel="Dividend"
                        money={input.Dividend}
                        name="Dividend"
                        onChange={myChangeEvent}
                    />
                    <InputMoney
                        xlabel="Capital Gain"
                        money={input.CapitalGain}
                        name="CapitalGain"
                        onChange={myChangeEvent}
                    />
                    <InputMoney
                        xlabel="Carrying Cost"
                        money={input.CarryingCost}
                        name="CarryingCost"
                        onChange={myChangeEvent}
                    />
                    <InputMoney
                        xlabel="RRSP Contrib"
                        money={input.RRSPContribution}
                        name="RRSPContribution"
                        onChange={myChangeEvent}
                    />
                </Stack>
            </Box>
        </Stack >
    )
}

// const TaxOutputList = ({ list }) => {
//     return (
//         {
//             Arrayify(SampleTaxe).map((value, name) => (
//                 <Stack direction={row, spacing = { 2}}>

//                     <Typography>
//                         {name}
//                     </Typography>
//                     <Typography>
//                         {value}
//                         list.Value
//                     </Typography>
//                 </Stack>
//             ))
//         }
//     )
// }


const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: activeToggleColor,
        color: '#ffffff',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(15),
        // border: '1px solid #dadde9',
    },
}));


const TaxOutputLine = ({ name, value, pct, tooltip = "", highlight = false }) => {
    return (
        <HtmlTooltip
            title={tooltip !== "" ?
                <span
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(tooltip) }}
                />
                : ""
            }
        // title={
        //     <>
        //         <div>First line of text</div>
        //         <div>Second line of text</div>
        //     </>
        // }
        >
            <TextField
                label={name}
                value={pct ? value + "%" : Money({ Value: value, Type: "Never" })}
                disabled={false}
                variant="standard"
                color={highlight ? "creditsRemaining" : "primary"}
                // color="error"
                focused={highlight}
                slotProps={{
                    input: {
                        disableUnderline: true, // This removes the standard variant's underline
                        sx: {
                            mt: 0,
                        },
                    },
                    inputLabel: {
                        sx: {
                            my: 1,
                        },
                    },
                }}
                sx={{
                    input: {
                        color: highlight ? creditsRemainingColor : "primary",
                    }
                }}
            // this works but it seems odd
            // sx={{
            //     '& .MuiInputBase-input': {
            //         textAlign: 'right',
            //         '&::placeholder': {
            //             textAlign: 'right',
            //         },
            //     },
            // }}
            />
        </HtmlTooltip >
    )
}

const TooltipLines = (map) => {
    let s = ""
    if (map === null) {
        return s
    }

    Object.entries(map).forEach(([key, value]) => {
        s += "<div style='display: flex; '> "
        s += "<div style='margin-right: 10px;'>" + key + ":    </div>"
        s += "<div style='display: flex; justify-content: flex-end; margin-left: auto;margin-right: 0;'>" + Money({ Value: value, Type: "Never" }) + "</div>"
        s += "</div>"
    })
    return s
}




const TaxOutputOne = ({ jurisdication, tax }) => {


    return (
        <Stack spacing={-1}>
            <Typography>
                {jurisdication}
            </Typography>
            {/* <TaxOutputLine
                name="Income"
                value={tax.Income}
            />
            <TaxOutputLine
                name="Taxable Income"
                value={tax.TaxableIncome}
            /> */}
            <TaxOutputLine
                name="Tax (pre-credits)"
                value={tax.BaseTax}
                tooltip={TooltipLines(tax.TaxDetails)}
            />
            <TaxOutputLine
                name="Credits"
                value={tax.CreditTotal}
                tooltip={TooltipLines(tax.CreditDetails)}
                highlight={tax.CreditsRemaining}
            />
            <TaxOutputLine
                name="Net Tax"
                value={tax.Tax}
                tooltip={TooltipLines(tax.CreditsRemainingValue)}
                highlight={tax.CreditsRemaining}
            />
            <TaxOutputLine
                name="Tax Rate"
                value={tax.Overall_tax_rate}
                pct={true}
            />
            <TaxOutputLine
                name="Marginal Rate"
                value={tax.Marginal_tax_rate}
                pct={true}
            />
        </Stack>
    )
}

const TaxOutputSummary = ({ tax }) => {
    return (
        <Stack spacing={-1}>
            {/* <Typography>
                Total
            </Typography> */}
            <TaxOutputLine
                name="Income"
                value={tax.Income}
            />
            <TaxOutputLine
                name="Taxable Income"
                value={tax.TaxableIncome}
                tooltip={TooltipLines(tax.TaxableIncomeDetails)}
            />
            <TaxOutputLine
                name="Net Tax"
                value={tax.Tax}
            />
            <TaxOutputLine
                name="Tax Rate"
                value={tax.Overall_tax_rate}
                pct={true}
            />
            <TaxOutputLine
                name="Marginal Rate"
                value={tax.Marginal_tax_rate}
                pct={true}
            />
        </Stack>
    )
}

const TaxOutput = ({ province, output }) => {
    return (
        <Stack spacing={4}>
            <TaxOutputSummary
                tax={output.Summary}
            />
            <Stack direction="row" spacing={2}>
                <TaxOutputOne
                    jurisdication="Federal"
                    tax={output.Federal}
                />
                <TaxOutputOne
                    jurisdication={province}
                    tax={output.Provincial}
                />
            </Stack>


        </Stack>
    )
}


const OneTax = ({ st, avail, onChange, onSubmit, onDelete }) => {
    return (
        <Box
            sx={{
                p: 2,
                border: '1px solid lightgrey',
            }}
        >

            <Stack spacing={2}>
                <TaxInput
                    input={st.In}
                    onChange={onChange}
                    onSubmit={onSubmit}
                    onDelete={onDelete}
                    avail={avail}
                />
                <TaxOutput
                    province={st.In.Province}
                    output={st.Out}
                />
            </Stack >
        </Box>
    )
}


const SimpleTax = ({ st, avail, onChange, onSubmit, onDelete }) => {
    const myChangeVI = (v, i) => {
        st[i].In = v
        onChange(st)
    }

    return (
        <Stack direction="row" spacing={2}>
            {Arrayify(st).map((d, i) => (
                <OneTax
                    key={"tax" + i}
                    st={d}
                    onChange={(v) => myChangeVI(v, i)}
                    onSubmit={() => onSubmit(i)}
                    onDelete={() => onDelete(d.Id)}
                    avail={avail}

                />
            ))}
        </Stack>
    )
}


const newTax = {
    Id: 0,
    In: {
        Label: "",
        Client: "",
        Notes: "",
        Year: new Date().getFullYear(),
        Province: "ON",
        Employment: 0,
        PensionIncome: 0,
        Income: 0,
        Dividend: 0,
        CapitalGain: 0,
        CarryingCost: 0,
        RRSPContribution: 0,
    },
    Out: {
        Provincial: {
            Income: 0,
            TaxableIncome: 0,
            BaseTax: 0,
            Tax: 0,
            TaxDetails: {},
            CreditTotal: 0,
            CreditDetails: {},
            Marginal_tax_rate: 0,
            Overall_tax_rate: 0,
            CreditsRemaining: false,
            CreditsRemainingValue: {}
        },
        Federal: {
            Income: 0,
            TaxableIncome: 0,
            BaseTax: 0,
            Tax: 0,
            TaxDetails: {},
            CreditTotal: 0,
            CreditDetails: {},
            Marginal_tax_rate: 0,
            Overall_tax_rate: 0,
            CreditsRemaining: false,
            CreditsRemainingValue: {}
        },
        Summary: {
            Income: 0,
            TaxableIncome: 0,
            TaxableIncomeDetails: {},
            Tax: 0,
            Marginal_tax_rate: 0,
            Overall_tax_rate: 0,
        }
    }
}


export const SimpleTaxDialog = ({ clientJson, show, onClose }) => {
    const [errors, setErrors] = useState({})
    const [errmsg, setErrmsg] = useState("")
    const [data, setData] = useState({})


    const SetupData = (json) => {
        let err = ""
        if (json) {
            if (Arrayify(json.TaxCalc).length === 0) {

                let cl = Object.keys(json.Avail.ClientData)
                if (Arrayify(cl).length > 0 && cl[0] !== "") {
                    json.TaxCalc = myAdd_(json.TaxCalc, cl[0])
                } else {
                    err = "You must select a client to be able to use the Tax Calculator."
                }

            }
            setData(json)
        }
        setErrmsg(err)

    }


    const getInputData = () => {
        const url = ScenOptionUrl_spec(clientJson, APIs_simpleTax);
        ftchPlus(url, getOptions)
            .then((json) => {
                SetupData(json)
            })
            .catch((error) => {
                //console.log(error.message);
                setErrmsg(error.message)
            });

    };

    const RunSaveData = () => {

        const url = ScenOptionUrl_spec(clientJson, APIs_simpleTax);
        var req = putOptions;

        req.body = JSON.stringify(data);
        GoogleAnalyticsEvent("taxCalc", "run", "", {})

        //console.log(req.body)
        ftchPlus(url, req)
            .then((json) => {
                SetupData(json)
            })
            .catch((error) => {
                console.log(error.message);
                setErrmsg(error.message)
            });
        return ""

    };

    const mySubmit = (i) => {
        //console.log(data)
        RunSaveData()
    }


    useEffect(() => {
        if (show) {
            //setDiaDelete(false)
            errorClear(errors)
            setErrmsg("")
            //setDeleted(false)

            getInputData("");
        }
    }, [show]);


    const myChange_any = (n, v) => {
        let nf = {
            ...data,
            [n]: v,
        };
        //console.log(data)
        //console.log(nf)
        setData(nf)
    };


    const myClose = () => {
        onClose()

    }

    const myAdd_ = (tc, n) => {
        if (n && n !== "") {
            let nt = structuredClone(newTax);
            nt.In.Client = n
            let json = [];
            if (tc) {
                json = tc.slice();
                nt.Id = Math.max(...tc.map((o) => o.Id), 0) + 1;
            }
            json.push(nt);
            return json
        }
    }

    const myAdd = () => {
        if (Object.hasOwn(data.Avail.ClientData, clientJson.name)) {
            let nt = myAdd_(data.TaxCalc, clientJson.name)

            myChange_any("TaxCalc", nt);
        } else {
            setErrmsg("You must select a client to be able to use the Tax Calculator.")
        }
    }

    const myDelete = (i) => {
        let nt = data.TaxCalc.slice();
        //console.log(data)
        //console.log(i)
        let json = nt.filter((o) => o.Id !== i);
        //console.log(json)
        myChange_any("TaxCalc", json);
    }

    const myChange = (v) => {
        //console.log(data)
        let nf = structuredClone(data)
        //nf.In.Client = clientJson.name
        nf = set(nf, "TaxCalc", v)
        //console.log(nf)
        setData(nf)
    }

    return (
        <AddDialog
            clientJson={clientJson}
            accountType={"TaxCalculator"}
            //c_callback={c_callback}
            onClose={myClose}
            open={show}
            clients={null}
            client={null}
            label={"Tax Calculator"}
            //onClientChange={btnClientChanged}
            onSubmit={mySubmit}
            errors={errors}
            errmsg={errmsg}
            //deleted={deleted}
            noSubmit={true}
        >
            <Stack sx={{ mx: 4, mb: 4 }}>
                {clientJson && clientJson.name !== null && (

                    <Stack direction="row" spacing={2}>
                        <Stack spacing={4} sx={{ py: 1 }}>
                            <CollapseAdd
                                onClick={myAdd}
                                tooltip="Add a new year"
                            />
                            {data && (true || Arrayify(data.TaxCalc).length > 0) && (
                                <FontAwesomeIcon
                                    icon={faRotateRight}
                                    onClick={mySubmit}
                                    size={iconSize}
                                    color={myOwnFPColor}
                                />
                            )}
                        </Stack>


                        <SimpleTax
                            st={data.TaxCalc}
                            onChange={myChange}
                            avail={data.Avail}
                            onSubmit={mySubmit}
                            onDelete={myDelete}
                        />
                    </Stack>
                )}
            </Stack>
        </AddDialog>
    )
}